import { ReactNode } from 'react';
import { useFormContext, FieldError, FieldValues } from 'react-hook-form';
import { Flex, Text } from '@radix-ui/themes';
import { FieldConfig } from '../types';

interface FieldWrapperProps<TFormValues extends FieldValues> {
    config: FieldConfig<TFormValues>;
    children: ReactNode;
}

export const FieldWrapper = <TFormValues extends FieldValues>({
    config,
    children,
}: FieldWrapperProps<TFormValues>) => {
    const {
        formState: { errors },
    } = useFormContext<TFormValues>();
    const error = errors[config.name as string] as FieldError | undefined;

    return (
        <Flex direction='column' gap='1' mb='3'>
            {config.type !== 'checkbox' && (
                <Text as='label' size='2' weight='bold'>
                    {config.label}{' '}
                    {config.validation?.required && <Text color='red'>*</Text>}
                </Text>
            )}

            {children}

            {error && (
                <Text color='red' size='1'>
                    {error.message}
                </Text>
            )}
        </Flex>
    );
};
